import { buildLSWHPrompt, buildSubjectPrompt, buildVariableSubjectPrompt } from "./aiPrompts";

const LSWH_CHAR_LIMIT = 2000;
const LANGUAGE_CHAR_LIMIT = 1000;
const NATIVE_LANGUAGE_CHAR_LIMIT = 1000;
const FRENCH_CHAR_LIMIT = 1000;
const MATHEMATICS_CHAR_LIMIT = 1000;
const SCIENCE_CHAR_LIMIT = 1000;
const HISTORY_CHAR_LIMIT = 1000;
const GEOGRAPHY_CHAR_LIMIT = 1000;
const HPPE_CHAR_LIMIT = 1000;
const ARTS_CHAR_LIMIT = 1000;
const OPTIONAL_STUDIES_CHAR_LIMIT = 1000;

export const LSWH_CONFIG = {
  systemPrompt: buildLSWHPrompt(LSWH_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    daysAbsent: v.daysAbsent,
    timesLate: v.timesLate,
    responsibility1: v.responsibility1,
    organization1: v.organization1,
    independentWork1: v.independentWork1,
    collaboration1: v.collaboration1,
    initiative1: v.initiative1,
    selfRegulation1: v.selfRegulation1,
    responsibility2: v.responsibility2,
    organization2: v.organization2,
    independentWork2: v.independentWork2,
    collaboration2: v.collaboration2,
    initiative2: v.initiative2,
    selfRegulation2: v.selfRegulation2,
  }),
};

export const LANGUAGE_CONFIG = {
  systemPrompt: buildSubjectPrompt("Language", LANGUAGE_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    languagePlan: v.languagePlan,
    languageGrade1: v.languageGrade1,
    languageMedian1: v.languageMedian1,
    languageGrade2: v.languageGrade2,
    languageMedian2: v.languageMedian2,
  }),
};

export const NATIVE_LANGUAGE_CONFIG = {
  systemPrompt: buildVariableSubjectPrompt("nativeLanguage", NATIVE_LANGUAGE_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    nativeLanguage: v.nativeLanguage,
    nativeLanguagePlan: v.nativeLanguagePlan,
    nativeLanguageGrade1: v.nativeLanguageGrade1,
    nativeLanguageMedian1: v.nativeLanguageMedian1,
    nativeLanguageGrade2: v.nativeLanguageGrade2,
    nativeLanguageMedian2: v.nativeLanguageMedian2,
  }),
};

export const FRENCH_CONFIG = {
  systemPrompt: buildSubjectPrompt("French", FRENCH_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    frenchPlan: v.frenchPlan,
    frenchListeningGrade1: v.frenchListeningGrade1,
    frenchListeningMedian1: v.frenchListeningMedian1,
    frenchListeningGrade2: v.frenchListeningGrade2,
    frenchListeningMedian2: v.frenchListeningMedian2,
    frenchSpeakingGrade1: v.frenchSpeakingGrade1,
    frenchSpeakingMedian1: v.frenchSpeakingMedian1,
    frenchSpeakingGrade2: v.frenchSpeakingGrade2,
    frenchSpeakingMedian2: v.frenchSpeakingMedian2,
    frenchReadingGrade1: v.frenchReadingGrade1,
    frenchReadingMedian1: v.frenchReadingMedian1,
    frenchReadingGrade2: v.frenchReadingGrade2,
    frenchReadingMedian2: v.frenchReadingMedian2,
    frenchWritingGrade1: v.frenchWritingGrade1,
    frenchWritingMedian1: v.frenchWritingMedian1,
    frenchWritingGrade2: v.frenchWritingGrade2,
    frenchWritingMedian2: v.frenchWritingMedian2,
  }),
};

export const MATHEMATICS_CONFIG = {
  systemPrompt: buildSubjectPrompt("Mathematics", MATHEMATICS_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    mathematicsPlan: v.mathematicsPlan,
    mathematicsGrade1: v.mathematicsGrade1,
    mathematicsMedian1: v.mathematicsMedian1,
    mathematicsGrade2: v.mathematicsGrade2,
    mathematicsMedian2: v.mathematicsMedian2,
  }),
};

export const SCIENCE_CONFIG = {
  systemPrompt: buildSubjectPrompt("Science & Technology", SCIENCE_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    scienceAndTechnologyPlan: v.scienceAndTechnologyPlan,
    scienceAndTechnologyGrade1: v.scienceAndTechnologyGrade1,
    scienceAndTechnologyMedian1: v.scienceAndTechnologyMedian1,
    scienceAndTechnologyGrade2: v.scienceAndTechnologyGrade2,
    scienceAndTechnologyMedian2: v.scienceAndTechnologyMedian2,
  }),
};

export const HISTORY_CONFIG = {
  systemPrompt: buildSubjectPrompt("History", HISTORY_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    historyPlan: v.historyPlan,
    historyGrade1: v.historyGrade1,
    historyMedian1: v.historyMedian1,
    historyGrade2: v.historyGrade2,
    historyMedian2: v.historyMedian2,
  }),
};

export const GEOGRAPHY_CONFIG = {
  systemPrompt: buildSubjectPrompt("Geography", GEOGRAPHY_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    geographyPlan: v.geographyPlan,
    geographyGrade1: v.geographyGrade1,
    geographyMedian1: v.geographyMedian1,
    geographyGrade2: v.geographyGrade2,
    geographyMedian2: v.geographyMedian2,
  }),
};

export const HPPE_CONFIG = {
  systemPrompt: buildSubjectPrompt("Health & Physical Education", HPPE_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    healthEducationPlan: v.healthEducationPlan,
    healthEducationGrade1: v.healthEducationGrade1,
    healthEducationMedian1: v.healthEducationMedian1,
    healthEducationGrade2: v.healthEducationGrade2,
    healthEducationMedian2: v.healthEducationMedian2,
    physicalEducationPlan: v.physicalEducationPlan,
    physicalEducationGrade1: v.physicalEducationGrade1,
    physicalEducationMedian1: v.physicalEducationMedian1,
    physicalEducationGrade2: v.physicalEducationGrade2,
    physicalEducationMedian2: v.physicalEducationMedian2,
  }),
};

export const ARTS_CONFIG = {
  systemPrompt: buildSubjectPrompt("The Arts", ARTS_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    artsHeader: v.artsHeader,
    arts1: v.arts1,
    arts1Grade1: v.arts1Grade1,
    arts1Median1: v.arts1Median1,
    arts1Grade2: v.arts1Grade2,
    arts1Median2: v.arts1Median2,
    arts2: v.arts2,
    arts2Grade1: v.arts2Grade1,
    arts2Median1: v.arts2Median1,
    arts2Grade2: v.arts2Grade2,
    arts2Median2: v.arts2Median2,
    arts3: v.arts3,
    arts3Grade1: v.arts3Grade1,
    arts3Median1: v.arts3Median1,
    arts3Grade2: v.arts3Grade2,
    arts3Median2: v.arts3Median2,
    arts4: v.arts4,
    arts4Grade1: v.arts4Grade1,
    arts4Median1: v.arts4Median1,
    arts4Grade2: v.arts4Grade2,
    arts4Median2: v.arts4Median2,
  }),
};

export const OPTIONAL_STUDIES_CONFIG = {
  systemPrompt: buildVariableSubjectPrompt("optionalStudies", OPTIONAL_STUDIES_CHAR_LIMIT),
  getStudentReportInfo: (v) => ({
    optionalStudies: v.optionalStudies,
    optionalStudiesPlan: v.optionalStudiesPlan,
    optionalStudiesGrade1: v.optionalStudiesGrade1,
    optionalStudiesGrade2: v.optionalStudiesGrade2,
  }),
};
